<div id="asistido-fin" class="form-width-size first-container-options-xs d-flex justify-content-center align-items-center flex-column position-relative m-t-xs-20" action="">
  
  <div class="container-logo-steps-xs d-flex d-md-none align-self-start">
    <img class="logo-img-size logo__astronaut" [src]="url_img.logo_blue" alt="">
  </div>

  <div class="p-y-11 p-y-xs-0 m-t-xs-70">
    <div class="d-block m-b-40 w-100">
      <!--!Sólo para Apertura asistida-->
      <p class=" heading-b-m-24 text-start line-height-20 text-start m-b-20" *ngIf="isResponsive">
        <!--!en responsive se debe mostrar el nombre de la persona-->
        <span class="d-block d-md-none">Gracias, <span class="first-letter-capitalize">{{name[0]}}</span>.</span>
        Tu folio de preregistro es {{generalData.cx_folio}}
      </p>

      <p class=" heading-b-m-24 text-start line-height-20 text-start m-b-20" *ngIf="!isResponsive">
        Tu folio de preregistro es {{generalData.cx_folio}}
      </p>
      <br>
      <!--!Termina caso de Apertura autonoma-->
      <p class="paragraph-b-r-16 m-b-22 m-b-xs-34">En 24 horas hábiles recibirás un email para continuar con el
        proceso de apertura de tu contrato Bursanet. Si no lo recibes,
        por favor, revisa tu carpeta de SPAM. <br><br>
        Si tienes dudas llama al <a class="link-generic-transparent" href="tel:55 5268 0807">55 5268 0807</a>  o envíanos un email a
       <a class="link-generic-transparent" href="mailto:bursanet@actinver.com.mx">bursanet&#64;actinver.com.mx</a>  o un mensaje directo a través de
        nuestras redes sociales:</p>
      <div class="container-social-style">
        <a [href]="url.social_network.facebook" target="_blank" (click)="gtagSocial('FB')"><img [src]="img.social_network.facebook" alt=""></a>        
        <a [href]="url.social_network.instagram" target="_blank" (click)="gtagSocial('IG')"><img [src]="img.social_network.instagram" alt=""></a>
        <a [href]="url.social_network.ex" target="_blank" (click)="gtagSocial('T')"><img [src]="img.social_network.ex" alt=""></a>
      </div>
    </div>
  </div>
</div>
<img src='https://www.rankia.com/pixel/casa-bolsa-Bursanet-registro-asistido' width='1' height='1' *ngIf="from=='rankia'"/>
